import { APIS, TENANT_ID } from "../../../../utils/api-factory"
import { POST_HEADER, TENANT_POST_HEADER, TENANT_HEADER } from "../../../../utils/apiHeaders"


export const getMArketingPerformanceStatsByDate = (sDate, eDate, callBack) => {
  fetch(APIS.GET_MARKETING_PERFORMANCE_STATS_BY_DATE + sDate + "&endDate=" + eDate, TENANT_HEADER)
    .then(res => res.json())
    .then(json => {
      callBack(json)
    })
}
export const getMArketingPerformanceStatsByDateNew = (sDate, eDate,type,dataType, callBack) => {
  fetch(APIS.GET_MARKETING_PERFORMANCE_STATS_BY_DATE_NEW + sDate + "&eDate=" + eDate + "&dateType=" + type + "&dataType=" + dataType, TENANT_HEADER)
    .then(res => res.json())
    .then(json => {
      callBack(json)
    })
}
export const getLatestEventTimeStamp = (callBack) => {
  fetch(APIS.GET_LATEST_EVENT_TIMESTAMP , TENANT_HEADER)
    .then(res => res.json())
    .then(json => {
      callBack(json)
    })
}
export const getLeadsByStatusDate = (sDate,eDate,status,callBack) => {
  fetch(APIS.GET_LEADS_BY_STATUS_DATE +sDate + "&endDate=" + eDate  + "&status=" + status)
    .then(res => res.json())
    .then(json => {
      callBack(json)
    })
}
export const DownloadLeadsByStatusDate = (sDate, eDate, status, callBack) => {
  fetch(APIS.DOWNLOAD_LEADS_BY_STATUS_DATE + sDate + "&endDate=" + eDate + "&status=" + status)
     .then(res => res.blob())
    .then(data => {
      var blob = new Blob([data], { type: 'application/vnd.ms-excel' })
      var excelBlob = new Blob(
        [data],
        { type: 'application/vnd.ms-excel' },
        'excel.xls'
      )
      var downloadUrl = URL.createObjectURL(blob)
      var a = document.createElement('a')
      a.href = downloadUrl
      a.download = 'Leads.xls'
      document.body.appendChild(a)
      a.click()
      callBack(data)
    })
};
export const getAllApplicationStatsByDate = (sDate, eDate, callBack) => {
  fetch(APIS.ALL_APLLICATION_STATS + sDate + '&endDate=' + eDate)
    .then(res => res.json())
    .then(json => {
      callBack(json)
    })
    .catch(error => {
      console.log(error);
    })
}


export const getAggregatedcountByFormStatusByBucketType = (sDate, eDate, type, callBack) => {
  fetch(APIS.GET_AGGREGATED_COUNT_BY_FORM_STATUS_BY_BUCKET_TYPE + sDate + "&endDate=" + eDate + "&bucketType=" + type)
    .then(res => res.json())
    .then(res => {
      callBack(res)
    })
    .catch(e => {
      callBack("")
    })
}
export const getAggregatorDetailsByDateFilter = (sDate, eDate, id, callBack) => {
  fetch(APIS.GET_AGGREGATOR_DETAILS_BY_DATE_FILTERS + sDate + "&endDate=" + eDate + "&aggregatorId=" + id, TENANT_HEADER)
    .then(res => res.json())
    .then(res => {
      callBack(res)
    })
    .catch(e => {
      callBack("")
    })
}
export const getLeakageAnalysisDetailsByDateFilter = (sDate, eDate, callBack) => {
  fetch(APIS.GET_LEAKAGE_ANALYSIS_DETAILS_BY_DATE_FILTERS + sDate + "&endDate=" + eDate, TENANT_HEADER)
    .then(res => res.json())
    .then(res => {
      callBack(res)
    })
    .catch(e => {
      callBack("")
    })
}
export const getAggregatorLeadsPayoutByDate = (sDate, eDate, callBack) => {
  fetch(APIS.GET_AGGREGATOR_LEADS_PAYOUT_BY_DATE + sDate + "&endDate=" + eDate, TENANT_HEADER)
    .then(res => res.json())
    .then(res => {
      callBack(res)
    })
    .catch(e => {
      callBack("")
    })
}
export const getLoanStatsByAggregatorIdbyName = (sDate, eDate, id,name, callBack) => {
  fetch(APIS.GET_LOAN_STATS_BY_AGGREGATOR_ID_BYDATE + sDate + "&endDate=" + eDate + "&aggregatorId=" + id + "&aggregatorName=" + name, TENANT_HEADER)
    .then(res => res.json())
    .then(res => {
      callBack(res)
    })
    .catch(e => {
      callBack("")
    })
}
export const getAggrrgaotrEventsByAggregatorIdbyName = (sDate, eDate, id, callBack) => {
  fetch(APIS.GET_AGGREGATOR_EVENTS_AGGREGATOR_ID_BYDATE + sDate + "&endDate=" + eDate + "&aggregatorId=" + id, TENANT_HEADER)
    .then(res => res.json())
    .then(res => {
      callBack(res)
    })
    .catch(e => {
      callBack("")
    })
}
export const getPartnersByAggregatorIdbyName = (sDate, eDate, id, callBack) => {
  fetch(APIS.GET_PARTNERS_BY_AGGREGATOR_ID_BY_DATE + sDate + "&endDate=" + eDate + "&aggregatorId=" + id, TENANT_HEADER)
    .then(res => res.json())
    .then(res => {
      callBack(res)
    })
    .catch(e => {
      callBack("")
    })
}
export const getcampaignsByAggregatorIdbyName = (sDate, eDate, id, callBack) => {
  fetch(APIS.GET_CAMPAIGN_BY_AGGREGATOR_ID_BY_DATE + sDate + "&endDate=" + eDate + "&aggregatorId=" + id, TENANT_HEADER)
    .then(res => res.json())
    .then(res => {
      callBack(res)
    })
    .catch(e => {
      callBack("")
    })
}
export const downloadCampaignsByAggregatorId = (sDate, eDate, id, callBack) => {
  fetch(APIS.DOWNLOAD_CAMPAIGNS_BY_AGGREGATOR_ID + sDate + "&endDate=" + eDate + "&aggregatorId=" + id, TENANT_HEADER)
    .then(res => {
      if (!res.ok) throw new Error("HTTP error " + res.status);
      const disposition = res.headers.get('content-disposition');
      let filename = `Campaigns_${sDate}_${eDate}.xlsx`;
      if (disposition && disposition.indexOf('attachment') !== -1) {
        const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        const matches = filenameRegex.exec(disposition);
        if (matches != null && matches[1]) { 
          filename = matches[1].replace(/['"]/g, '');
        }
      }
      return res.blob().then(blob => {
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        URL.revokeObjectURL(url);
        a.remove();
      });
    })
    .then(() => callBack({ success: true }))
    .catch(err => {
      console.error(err);
      callBack({ success: false, error: err });
    });
}
export const getLeadsByCampaignId = (sDate, eDate, aggregatorId, campaignId, callBack) => {
  fetch(APIS.GET_LEADS_BY_CAMPAIGN_ID + sDate + "&endDate=" + eDate + "&aggregatorId=" + aggregatorId + "&campaignId=" + campaignId, TENANT_HEADER)
    .then(res => res.json())
    .then(res => {
      callBack(res)
    })
    .catch(e => {
      callBack("")
    })
}
export const downloadLeadsByCampaignId = (sDate, eDate, aggregatorId, campaignId, callBack) => {
  fetch(APIS.DOWNLOAD_LEADS_BY_CAMPAIGN_ID + sDate + "&endDate=" + eDate + "&aggregatorId=" + aggregatorId + "&campaignId=" + campaignId, TENANT_HEADER)
    .then(res => {
      if (!res.ok) throw new Error("HTTP error " + res.status);
      const disposition = res.headers.get('content-disposition');
      let filename = `Leads_${campaignId}_${sDate}_${eDate}.xlsx`;
      if (disposition && disposition.indexOf('attachment') !== -1) {
        const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        const matches = filenameRegex.exec(disposition);
        if (matches != null && matches[1]) { 
          filename = matches[1].replace(/['"]/g, '');
        }
      }
      return res.blob().then(blob => {
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        URL.revokeObjectURL(url);
        a.remove();
      });
    })
    .then(() => callBack({ success: true }))
    .catch(err => {
      console.error(err);
      callBack({ success: false, error: err });
    });
}
export const getaggregatorDataByAggregatorIdbyName = (sDate, eDate, id, name, callBack) => {
  fetch(APIS.GET_AGRREGATOR_DATA_AGGREGATOR_ID_BY_DATE + sDate + "&endDate=" + eDate + "&aggregatorId=" + id +
    "&aggregatorName=" + name, TENANT_HEADER)
    .then(res => res.json())
    .then(res => {
      callBack(res)
    })
    .catch(e => {
      callBack("")
    })
}
export const getEventDataByAggregatorIdbyName = (id, callBack) => {
  fetch(APIS.GET_EVENT_DATA_AGGREGATOR_ID_BY_DATE + id, TENANT_HEADER)
    .then(res => res.json())
    .then(res => {
      callBack(res)
    })
    .catch(e => {
      callBack("")
    })
}
export const updateEventDataByAggregatorId = (id, body, callBack) => {
  fetch(APIS.UPDATE_EVENT_DATA_AGGREGATOR_ID + id, {
    method: 'PUT',
    headers: TENANT_POST_HEADER,
    body: JSON.stringify(body),
  })
    .then(res => res.json())
    .then(res => {
      callBack(res)
    })
    .catch(e => {
      callBack({ error: e })
    })
}
export const getBudgetAggregatorByData = (sDate, eDate, id, callBack) => {
  fetch(APIS.GET_BUDGET_AGGREGATOR_BY_DATA + sDate + "&endDate=" + eDate + "&aggregatorId=" + id, TENANT_HEADER)
    .then(res => res.json())
    .then(res => {
      callBack(res)
    })
    .catch(e => {
      callBack("")
    })
}
export const downloadApplicationAggregatorMapping = (sDate, eDate, callBack) => {
  fetch(APIS.DOWNLOAD_APPLICATION_AGGREGATOR_MAPPING + sDate + "&endDate=" + eDate, TENANT_HEADER)
    .then(res => {
      if (!res.ok) throw new Error("HTTP error " + res.status);
      const disposition = res.headers.get('content-disposition');
      let filename = `ApplicationAggregatorMapping_${sDate}_${eDate}.xls`;
      if (disposition && disposition.indexOf('attachment') !== -1) {
        const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        const matches = filenameRegex.exec(disposition);
        if (matches != null && matches[1]) { 
          filename = matches[1].replace(/['"]/g, '');
        }
      }
      return res.blob().then(blob => {
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        URL.revokeObjectURL(url);
        a.remove();
      });
    })
    .then(() => callBack({ success: true }))
    .catch(err => {
      console.error(err);
      callBack({ success: false, error: err });
    });
}
export const getBudgetStatsAggregatorByData = (sDate, eDate, id, name, callBack) => {
  fetch(APIS.GET_BUDGET_STATS_AGGREGATOR_BY_DATA + sDate + "&endDate=" + eDate + "&aggregatorId=" + id + "&aggregatorName=" + name, TENANT_HEADER)
    .then(res => res.json())
    .then(res => {
      callBack(res)
    })
    .catch(e => {
      callBack("")
    })
}
export const SavePArtnerDataByObject = (data, callBack) => {
  fetch(APIS.SAVE_PARTNER_DATA_BYOBJECT, {
    method: "POST",
    body: JSON.stringify(data),
    headers:TENANT_POST_HEADER
  })
    .then(res => res.json())
    .then(res => {
      callBack(res)
    })
    .catch(e => {
      callBack("")
    })
}

export const getLiveReportDailyTrendByDate = (sDate, eDate,dateType, callBack) => {
  fetch(
    APIS.GET_AGGREGATOR_LOAN_STATS_BY_DATE + sDate + "&eDate=" + eDate  + "&dateType=" + dateType,
    TENANT_HEADER,
  )
    .then((res) => res.json())
    .then((json) => {
      callBack(json);
    });
};

export const getLiveReportFunnelDataByDate = (sDate, eDate, callBack) => {
  fetch(
    APIS.GET_LIVE_REPORT_OVERVIEW_FUNNEL_DATA_BY_DATE + sDate + "&endDate=" + eDate,
    TENANT_HEADER,
  )
    .then((res) => res.json())
    .then((json) => {
      callBack(json);
    });
};

export const getRejectionHeatMapDataByDate = (sDate, eDate, callBack) => {
  fetch(
    APIS.GET_REJECTION_HEATMAP_DATA_BY_DATE + sDate + "&endDate=" + eDate,
    TENANT_HEADER,
  )
    .then((res) => res.json())
    .then((json) => {
      callBack(json);
    });
};

export const getRejectionChartDataByDate = (sDate, eDate, callBack) => {
  fetch(
    APIS.GET_REJECTION_CHART_DATA_BY_DATE + sDate + "&endDate=" + eDate,
    TENANT_HEADER,
  )
    .then((res) => res.json())
    .then((json) => {
      callBack(json);
    });
};


export const getAggregatorDetailDataByDate = (sDate, eDate, callBack) => {
  fetch(
    APIS.GET_AGGREGATOR_DETAILS_DATA_BY_DATE + sDate + "&endDate=" + eDate,
    TENANT_HEADER,
  )
    .then((res) => res.json())
    .then((json) => {
      callBack(json);
    });
};

export const getConversionDetailDataByDate = (sDate, eDate, callBack) => {
  fetch(
    APIS.GET_CONVERSION_DETAILS_DATA_BY_DATE + sDate + "&endDate=" + eDate,
    TENANT_HEADER,
  )
    .then((res) => res.json())
    .then((json) => {
      callBack(json);
    });
};

export const getBusinessAtsChartDataByDate = (sDate, eDate, callBack) => {
  fetch(
    APIS.GET_BUSINESS_ATS_CHART_DATA_BY_DATE + sDate + "&endDate=" + eDate,
    TENANT_HEADER,
  )
    .then((res) => res.json())
    .then((json) => {
      callBack(json);
    });
};

export const getBusinessContributionDataByDate = (sDate, eDate, callBack) => {
  fetch(
    APIS.GET_BUSINESS_CONTRIBUTION_DATA_BY_DATE + sDate + "&endDate=" + eDate,
    TENANT_HEADER,
  )
    .then((res) => res.json())
    .then((json) => {
      callBack(json);
    });
};
export const getUserDetailsIncompleteStatsByDate = (sDate, eDate, callBack) => {
  fetch(
    APIS.GET_USER_DETAILS_INCOMPLETE_FUNNEL_STATS_BY_DATE + sDate + "&endDate=" + eDate)
    .then((res) => res.json())
    .then((json) => {
      callBack(json);
    });
};
